<template>
  <v-container grid-list-xl>
    <v-layout column>
      <v-flex v-if="Business && Campaigns && Campaigns.isActive">
        <div v-if="$vuetify.breakpoint.xsOnly">
          <div class="text-center mt-4">
            <img v-if="Business.imageUrl" height="50" :src="Business.imageUrl" alt="Logo" />
            <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
            <div v-if="Business.phoneNumber">
              {{ Business.phoneNumber | USPhoneNumber }}
            </div>
            <div>
              <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
              }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
              <span v-if="Business.zip">{{ Business.zip }}</span>
            </div>
          </div>
        </div>

        <div v-else>
          <v-layout class="mt-4 mx-2 mr-4" align-content-space-between row wrap>
            <v-flex>
              <img v-if="Business.imageUrl" height="100" :src="Business.imageUrl" alt="Logo" />
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex>
              <div class="text-right">
                <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
                <div>
                  <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
                  }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
                  <span v-if="Business.zip">{{ Business.zip }}</span>
                </div>
                <div v-if="Business.phoneNumber">
                  {{ Business.phoneNumber | USPhoneNumber }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex v-if="Campaigns && Campaigns.isActive">
        <div class="black--text text-h4 font-weight-bold">
          {{ Campaigns.name }}
        </div>
        <v-layout row wrap>
          <v-flex xs12 md8>
            <v-layout column>
              <v-flex>
                <v-card class="mx-auto rounded-xl">
                  <v-img height="350" :src="Campaigns.imageUrl"></v-img>
                </v-card>
              </v-flex>
              <v-flex>
                <v-divider></v-divider>
                <div class="py-5"> Created {{ Campaigns.createdAt | moment("from", "now") }}</div>
                <v-divider></v-divider>
              </v-flex>
              <v-flex>
                <div v-html="Campaigns.description"></div>
              </v-flex>
            </v-layout>

          </v-flex>
          <v-flex xs12 md4>
            <v-card class="rounded-xl">
              <v-card-text>
                <v-layout column>
                  <v-flex>
                    <div>Raised</div>
                    <span class="text-h4 black--text font-weight-light">{{ Campaigns.dontationGoal | currency }}</span>
                  </v-flex>
                  <v-flex>
                    <v-progress-linear value="15"></v-progress-linear>
                    <div>{{Campaigns.donationCount}} donations</div>
                    <div>{{Campaigns.visitorCount}} 
                      <span v-if="Campaigns.visitorCount <= 1">visitor</span>
                      <span v-else>visitors</span>
                    </div>
                  </v-flex>

                  <v-flex>
                    <v-btn block large class="rounded-lg" @click="donationNow" color="success">Donate now</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

          </v-flex>
        </v-layout>




      </v-flex>
      <v-flex v-if="Campaigns && !Campaigns.isActive">
        <v-card flat>
          <v-card-text>
            <v-layout row>
              <v-flex sm4>
                <lottie
                  :options="defaultOptions"
                  v-on:animCreated="handleAnimation"
                />
              </v-flex>
              <v-flex sm4>
                <v-card-text>
                  <h2 class="display-1">This Link has Expired</h2>
                  <span class="caption mt-2"
                    >Please contact customer support to receive a new URL</span
                  >
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import campaignService from "@/modules/Campaign/service.js"
import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/pinjump.json";
export default {
  name: 'collectDonationByCampaign',
  data() {
    return {
      Campaigns: null,
      Business: null,
      defaultOptions: {
        animationData: animationData.default
      },
    }
  },
  created() {
    this.loadCampaign()
  },
  components: {
    Lottie,
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
    donationNow() {
      this.$router.push({ path: `/go/${this.Campaigns.code}/donate` });
    },
    loadCampaign() {
      let code = this.$route.params.id
      // console.log('getting code', code)
      campaignService
        .getCampaignById(code)
        .then((response) => {
          console.log("response campaign", response);
          if (!response.data) {
            this.$router.push({ name: "pagenotfound" });
          }
          if (response.data.isActive === false) {
            this.$router.push({ name: "pagenotfound" });
          }
          this.Campaigns = response.data
          this.Business = response.data.Business
        })
        .catch((error) => {
          console.log("error getting campaign", error);
          this.$router.push({ name: "pagenotfound" });
        });
    }
  }
}
</script>